export { default } from "./DownloadConfirmationNextLessonCard";
